import React from 'react';
import {
  MainContainer,
  Greet,
  Describe
} from '../app';

const MainContent = () => {
  return (
    <MainContainer>
      <article>
        <Greet>What's up? I'm Brad</Greet>
        <Describe>
          I build real things that solve real problems.
        </Describe>
        <p>Get in touch on <a href="https://www.linkedin.com/in/brad-flood/">LinkedIn</a>.</p>
        <p style={{fontSize: '4em', margin: 0}}><span role="img" aria-label="Cheers">👍🏼 😎 🏄‍♂️</span></p>
        <p>Cheers!<br />Brad</p>
      </article>
    </MainContainer>
  );
};

export default MainContent;



// WEBPACK FOOTER //
// ./src/components/MainContent.js